import React from "react"
import { Dialog, FlatButton, Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn } from "material-ui"
import strings from "../../localization/strings"
import { IDateRange, IPayrollPayCalendar, IPayrollTimeHierarchy } from "../../models"
import moment from "moment"
import ErrorIcon from "material-ui/svg-icons/alert/error"
import SuccessIcon from "material-ui/svg-icons/action/check-circle"
import { red500, green500, grey500, grey700 } from "material-ui/styles/colors"
import ToolTip from "react-portal-tooltip"
import { CSVLink } from "react-csv"
import _ from "lodash"
interface IProps {
    selectedPayCalendar: IPayrollPayCalendar
    payrollDates: IDateRange
    payrollTimeHierarchies: IPayrollTimeHierarchy[]
    exportEmployeeIds: string[]
    handleClose(): void
}

const ExportPayrollResultDialog: React.SFC<IProps> = (props: IProps) => {
    const payrollTimeHierarchies = _.cloneDeep(props.payrollTimeHierarchies)
    const exportPayrollTimeHierarchies = payrollTimeHierarchies.filter(i => {
        if (!i.ExportedData) return false
        i.ExportedData = i.ExportedData.filter(e => props.exportEmployeeIds.includes(e.ExportedEmployeeId))
        return i.ExportedData.length > 0
    })

    const checkExportSuccessHierarchy = (hierarchy: IPayrollTimeHierarchy): boolean => {
        return hierarchy.ExportedData.find(i => !i.IsExported) ? false : true
    }

    const faieldHierarchies = exportPayrollTimeHierarchies.filter(hierarchy => !checkExportSuccessHierarchy(hierarchy))

    const downloadData = [
        [strings.Payroll_Hierarchy, strings.Name, strings.Exported, strings.Exported_Date, strings.Exported_By, strings.Export_Note, strings.Audit]
    ]
    exportPayrollTimeHierarchies.forEach((hierarchy, index) => {
        index > 0 &&
            downloadData.push([])
        downloadData.push([`${hierarchy.HierarchyItem.Label}`])
        hierarchy.ExportedData.forEach(exportedData => {
            const employeeName = exportedData.ExportedEmployeeName
            const exported = exportedData ?
                exportedData.IsExported ?
                    strings.Exported :
                    strings.Failed :
                strings.Unexported
            const exportedDate = exportedData ? moment(exportedData.ExportedDateTime).format("MM-DD-YYYY") : ""
            const exportedBy = exportedData ? exportedData.ExportedUserName : ""
            let exportNote = ""
            let audit = ""
            const logs = exportedData && exportedData.AuditLogs && exportedData.AuditLogs.length > 0 ?
                exportedData.AuditLogs[exportedData.AuditLogs.length - 1] :
                ""
            const audits = logs.split("\rExportNote")
            if (audits.length > 1) {
                audit = audits[0]
                exportNote = audits[1]
            }
            else {
                audit = logs
            }
            downloadData.push(["", employeeName, exported, exportedDate, exportedBy, exportNote, audit])
        })
    })

    return (
        <Dialog
            open
            modal
            autoScrollBodyContent
            title={
                <div>
                    <div>{strings.Export_Payroll}</div>
                    <div style={{ fontSize: 16 }}>
                        {`${props.selectedPayCalendar.PayCalendarLabel} | ${moment(props.payrollDates.StartDate).format("MMMM Do YYYY")} - ${moment(props.payrollDates.EndDate).utc(true).format("MMMM Do YYYY")}`}
                    </div>
                </div>
            }
            actions={[
                <FlatButton
                    key="download_export_result"
                    style={{ float: "left" }}
                    children={
                        <CSVLink
                            key="csvlink"
                            data={downloadData}
                            style={{ textDecoration: "none", fontSize: 14, fontWeight: 500, color: grey700, textTransform: "uppercase", padding: 20 }}
                            filename="ExportPayrollResult.csv"
                        >
                            {strings.Download_Export_Result}
                        </CSVLink>
                    }
                />,
                <FlatButton
                    key="ok"
                    label={strings.OK}
                    primary
                    keyboardFocused
                    onClick={props.handleClose}
                />
            ]}
        >
            <div>
                <div style={{ padding: 20 }}>
                    <Table selectable={false}>
                        <TableHeader
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            enableSelectAll={false}
                        >
                            <TableRow style={{ height: 30 }}>
                                <TableHeaderColumn style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 25, textAlign: "center" }}>
                                    {faieldHierarchies.length > 0 ?
                                        <ErrorIcon style={{ color: red500, width: 20, height: 20, marginTop: 2 }} /> :
                                        <SuccessIcon style={{ color: green500, width: 20, height: 20, marginTop: 2 }} />
                                    }
                                </TableHeaderColumn>
                                <TableHeaderColumn style={{ height: 30, paddingLeft: 5, paddingRight: 5 }}>
                                    {`${strings.Execution_Result}       ${strings.Success}: ${exportPayrollTimeHierarchies.length - faieldHierarchies.length},  ${strings.Error}: ${faieldHierarchies.length}`}
                                </TableHeaderColumn>
                                <TableHeaderColumn style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 40, textAlign: "center" }}>
                                    {strings.Details}
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {exportPayrollTimeHierarchies.map((hierarchy, index) => {
                                const failed = !checkExportSuccessHierarchy(hierarchy)
                                return (
                                    <TableRow key={index} style={{ height: 25, borderBottom: "none" }}>
                                        <TableRowColumn style={{ height: 25, whiteSpace: "unset", paddingLeft: 5, paddingRight: 5, width: 25, textAlign: "center" }}>
                                            {`${index + 1})`}
                                        </TableRowColumn>
                                        <TableRowColumn style={{ height: 25, paddingLeft: 5, paddingRight: 5, whiteSpace: "unset", textAlign: "left" }}>
                                            {failed ?
                                                strings.formatString(strings.failure_export_payroll_hierarchy, hierarchy.HierarchyItem.Label) :
                                                strings.formatString(strings.success_export_payroll_hierarchy, hierarchy.HierarchyItem.Label)
                                            }
                                        </TableRowColumn>
                                        <TableRowColumn style={{ height: 25, whiteSpace: "unset", paddingLeft: 5, paddingRight: 5, width: 40, textAlign: "center" }}>
                                            <DetailCol
                                                hierarchy={hierarchy}
                                            />
                                        </TableRowColumn>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </div>
                {faieldHierarchies.length > 0 &&
                    <div style={{ marginTop: 20 }}>
                        {strings.export_failed_comment}
                    </div>
                }
            </div>
        </Dialog>
    )
}

export default ExportPayrollResultDialog


interface IDetailColProps {
    hierarchy: IPayrollTimeHierarchy
}
interface IDetailColState {
    open: boolean
}

class DetailCol extends React.Component<IDetailColProps, IDetailColState>  {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
    }

    render() {
        return (
            <div style={{ textAlign: "center" }}>
                <ToolTip
                    key="tooltip"
                    active={this.state.open}
                    position="left"
                    arrow="center"
                    parent={"#" + "export-payroll-result-detail-" + this.props.hierarchy.HierarchyItem.Id}
                    tooltipTimeout={50}
                >
                    <div style={{ padding: 10 }}>
                        <div>{`${strings.Total}: ${this.props.hierarchy.ExportedData.length}`}</div>
                        <div>{`${strings.Exported}: ${this.props.hierarchy.ExportedData.filter(i => i.IsExported).length}`}</div>
                    </div>
                </ToolTip>
                <i
                    key="icon"
                    id={"export-payroll-result-detail-" + this.props.hierarchy.HierarchyItem.Id}
                    data-intercom-target={"menu-Employees-Timecards-Btn-OpenDailyHistory"}
                    className="fa fa-info-circle"
                    style={{ color: grey500, marginRight: 5, cursor: "pointer", display: "inline-block" }}
                    onClick={e => {
                        e.stopPropagation()
                        this.setState({ open: !this.state.open })
                    }}
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}